import { Badge, Box, Flex, Text } from "@chakra-ui/react";
import { useSupportUnreadContext } from "contexts/SupportUnreadContext";

interface SupportTabsProps {
  activeTab: number;
  onTabChange: (index: number) => void;
  unreadMessagesCnt: number;
}

export default function SupportTabs({
  activeTab,
  onTabChange,
  unreadMessagesCnt,
}: SupportTabsProps) {
  const tabs = ["New request", "Messages"];
  const { unreadCount: supportUnreadCount } = useSupportUnreadContext();

  return (
    <Box
      borderRadius="12px"
      bg="#F5F7FA"
      p="16px 24px"
      border="1px solid #E6ECF3"
    >
      <Flex gap="32px">
        {tabs.map((tab, index) => (
          <Box
            key={index}
            px="9px"
            py="8px"
            cursor="pointer"
            borderBottom={
              activeTab === index
                ? "1px solid #3A7BFF"
                : "2px solid transparent"
            }
            onClick={() => onTabChange(index)}
          >
            <Text
              fontSize="14px"
              fontWeight={activeTab === index ? "600" : "400"}
              lineHeight="1.15"
              color={activeTab === index ? "#3A7BFF" : "#0B0E10"}
            >
              {tab}
              {supportUnreadCount > 0 && tab === "Messages" && (
                <Badge
                  bgColor="#EF4444"
                  sx={{
                    padding: "2px 8px !important",
                    borderRadius: "999px",
                    fontWeight: "600",
                    fontSize: "12px",
                    lineHeight: "16px",
                    color: "#FFF",
                    marginLeft: "8px",
                    minWidth: "20px",
                  }}
                >
                  {supportUnreadCount}
                </Badge>
              )}
            </Text>
          </Box>
        ))}
      </Flex>
    </Box>
  );
}
